<template>
  <div>
    <div class="container">
    <base-memo-upload></base-memo-upload>

    </div>
  </div>
</template>

<script>
export default {
  name: 'MemoUpload',
};
</script>

<style scoped>
/*For Footer use*/
.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
